import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";

// Pre-rendered pages ship static <title>/<meta>/<link> tags for crawlers
// (scripts/prerender.js). React re-renders its own, so drop these first to
// avoid duplicates and a stale title after client-side navigation.
document.querySelectorAll("head [data-prerender]").forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
